module.exports = __webpack_public_path__ + "static/media/400419_01.4f527c62.png";